module.exports = __webpack_public_path__ + "img/zanwu.faf32f4a.png";